"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlogFooter = void 0;

var react_1 = __importDefault(require("react"));

var BlogFooter_styles_1 = require("./BlogFooter.styles");

var react_share_1 = require("react-share");

var BlogFooter = function BlogFooter(props) {
  return react_1.default.createElement(BlogFooter_styles_1.BlogFooterWrapper, {
    "data-testid": "blog-footer"
  }, react_1.default.createElement(BlogFooter_styles_1.BlogShareArticleTitle, {
    "data-testid": "blog-footer-share-title"
  }, "Share this article"), react_1.default.createElement(BlogFooter_styles_1.BlogShareButtons, {
    "data-testid": "blog-footer-share-buttons"
  }, react_1.default.createElement(BlogFooter_styles_1.BlogTwitterShareButton, {
    "data-testid": "blog-footer-twitter-share",
    url: props.shareUrl
  }, react_1.default.createElement(react_share_1.TwitterIcon, {
    bgStyle: {
      fill: props.shareButtonBackgroundColour
    },
    size: 32,
    round: true
  })), react_1.default.createElement(BlogFooter_styles_1.BlogFacebookShareButton, {
    "data-testid": "blog-footer-facebook-share",
    url: props.shareUrl
  }, react_1.default.createElement(react_share_1.FacebookIcon, {
    bgStyle: {
      fill: props === null || props === void 0 ? void 0 : props.shareButtonBackgroundColour
    },
    size: 32,
    round: true
  })), react_1.default.createElement(BlogFooter_styles_1.BlogLinkedInShareButton, {
    "data-testid": "blog-footer-linkedin-share",
    url: props.shareUrl
  }, react_1.default.createElement(react_share_1.LinkedinIcon, {
    bgStyle: {
      fill: props === null || props === void 0 ? void 0 : props.shareButtonBackgroundColour
    },
    size: 32,
    round: true
  }))));
};

exports.BlogFooter = BlogFooter;